<script setup>
import { defineProps, defineEmits, ref, onMounted } from "vue";
import TreeView from "./TreeView.vue";
import { reactive } from "vue";

const props = defineProps({
  events: Array,
});

const expandAll = ref(false);

function createHierachy(paths) {
  const root = {};
  paths.forEach((path) => {
    const parts = path.target.split("/");
    let currentLevel = root;

    parts.forEach((part) => {
      if (!currentLevel[part]) {
        currentLevel[part] = {};
      }

      currentLevel = currentLevel[part];
    });
  });
  //console.log("Hierachy", root[""]);
  return root[""];
}

function createHierachy2(paths) {
  const root = {};
  paths.forEach((path) => {
    //console.log("Path", path);
    const parts = path.target.split("/");
    let currentLevel = root;

    parts.forEach((part, index) => {
      if (!currentLevel[part]) {
        currentLevel[part] = { ESFevents: [] };
      }
      if (index == parts.length - 1) {
        currentLevel[part].ESFevents.push(path);
      }

      currentLevel = currentLevel[part];
    });
  });
  //console.log("Hierachy", root[""]);
  return root[""];
}

function getKeys(object) {
  var keys = Object.keys(object);
  keys = keys.filter((key) => {
    if (key == "ESFevents") {
      return false;
    }
    return true;
  });
  keys.sort();
  //console.log(keys);
  return keys;
}

const hierachy = ref({});
const finished = ref(false);
const eventTypes = reactive([]);
const filteredEvents = reactive([]);
const displayEvents = [
  { value: "File:Unlink", displayValue: "Delete" },
  { value: "File:Create", displayValue: "Create" },
  { value: "File:Write", displayValue: "Write" },
  { value: "File:Rename", displayValue: "Rename" },
  { value: "yyy", displayValue: "yyy" },
  { value: "yyy", displayValue: "yyy" },
  { value: "yyy", displayValue: "yyy" },
  { value: "yyy", displayValue: "yyy" },
];
const allEventsSelected = ref(true);

function displayEvent(eventType) {
  let index = displayEvents.findIndex((event) => event.value == eventType);
  if (index >= 0) {
    return displayEvents[index].displayValue;
  }
  return eventType;
}

onMounted(() => {
  hierachy.value = createHierachy2(props.events);
  props.events.forEach((event) => {
    let index = eventTypes.findIndex((type) => type.name == event.eventtype);
    //console.log(index);
    if (index >= 0) {
      eventTypes[index].count++;
    } else {
      eventTypes.push({ name: event.eventtype, count: 1, selected: true });
    }
  });
  finished.value = true;
});

function updateAll(value) {
  console.log("Update All", value);
}

function updateTypeSelected() {
  finished.value = false;
  let events = props.events.filter((event) => {
    let index = eventTypes.findIndex((type) => type.name == event.eventtype);
    if (index >= 0) {
      if (eventTypes[index].selected) {
        return true;
      }
    }
    return false;
  });
  //console.log("Events", events);
  hierachy.value = createHierachy2(events);
  finished.value = true;
}
</script>

<template>
  <v-row>
    <v-col cols="3">
      <v-card>
        <v-card-title class="text-subtitle-1">File Change Types</v-card-title>
        <v-card-text>
          <v-col>
            <v-checkbox
              v-for="type in eventTypes"
              :key="type"
              :label="displayEvent(type.name) + ' (' + type.count + ')'"
              density="compact"
              hide-details
              v-model="type.selected"
              @update:modelValue="updateTypeSelected()"
            ></v-checkbox>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col v-if="finished">
      <v-card min-height="500">
        <v-card-text>
          <table v-if="hierachy">
            <tr>
              <td>
                <template v-for="object in getKeys(hierachy)" :key="object">
                  <TreeView
                    :item="hierachy[object]"
                    :rootName="object"
                    :expandAll="expandAll"
                  />
                </template>
              </td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
